import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';
import Menu from '../../components/Menu/Menu';
import Pagination from '../../components/Pagination/Pagination';
import Toast from '../../components/Toast/Toast';
import {
    deletePlan,
    getPlans,
    startPlan,
    stopPlan,
} from '../../services/PlansService';
import { confirmDelete } from '../../utils/confirmDialog';
import NewPlanButton from './NewPlanButton';
import PlanModal from './PlanModal';
import PlanRow from './PlanRow';

function Plans() {
    const defaultLocation = useLocation();

    function getPage(location) {
        if (!location) location = defaultLocation;
        return new URLSearchParams(location.search).get('page');
    }

    useEffect(() => {
        setPage(getPage(defaultLocation));
    }, [defaultLocation]);

    const [plans, setPlans] = useState([]);

    const [count, setCount] = useState(0);

    const [notification, setNotification] = useState({ type: '', text: '' });

    const [editPlan, setEditPlan] = useState({});

    const [page, setPage] = useState(getPage());

    useEffect(() => {
        getPlans(page || 1)
            .then(result => {
                setPlans(result.rows);
                setCount(result.count);
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({
                    type: 'error',
                    text: err.response ? err.response.data : err.message,
                });
            });
    }, [page]);

    function onEditClick(event) {
        const id = event.target.id.replace('edit', '');
        const plan = plans.find(m => m.id == id);
        setEditPlan({ ...plan });
    }

    function onStopClick(event) {
        const id = event.target.id.replace('stop', '');
        stopPlan(id)
            .then(result => {
                window.location.reload();
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({
                    type: 'error',
                    text: err.response ? err.response.data : err.message,
                });
            });
    }

    function onStartClick(event) {
        const id = event.target.id.replace('start', '');
        startPlan(id)
            .then(result => {
                window.location.reload();
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({
                    type: 'error',
                    text: err.response ? err.response.data : err.message,
                });
            });
    }

    function onDeleteClick(event) {
        const id = event.target.id.replace('delete', '');
        confirmDelete('This plan will be permanently deleted!').then(
            confirmed => {
                if (!confirmed) return;
                deletePlan(id)
                    .then(result => {
                        window.location.reload();
                    })
                    .catch(err => {
                        console.error(
                            err.response ? err.response.data : err.message,
                        );
                        setNotification({
                            type: 'error',
                            text: err.response
                                ? err.response.data
                                : err.message,
                        });
                    });
            },
        );
    }

    function onPlanSubmit(order) {
        window.location.reload();
    }

    return (
        <>
            <Menu />
            <main className="content">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <h2 className="h4">Plans</h2>
                    </div>
                    <div className="btn-toolbar mb-2 mb-md-0">
                        <div className="d-inline-flex align-items-center">
                            <NewPlanButton />
                        </div>
                    </div>
                </div>
                <div className="card card-body border-0 shadow table-wrapper table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th className="border-gray-200">Code</th>
                                <th className="border-gray-200">Name</th>
                                <th className="border-gray-200">
                                    Max. Automations
                                </th>
                                <th className="border-gray-200">
                                    Max. Monitors
                                </th>
                                <th className="border-gray-200">
                                    Max. Backtests/mo.
                                </th>
                                <th className="border-gray-200">
                                    Extra limits
                                </th>
                                <th className="border-gray-200">Futures</th>
                                <th className="border-gray-200">Launch</th>
                                <th className="border-gray-200">Strategies</th>
                                <th className="border-gray-200">Trial</th>
                                <th className="border-gray-200">Price/mo.</th>
                                <th className="border-gray-200">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {plans && plans.length ? (
                                plans.map(plan => (
                                    <PlanRow
                                        key={plan.id}
                                        data={plan}
                                        onEditClick={onEditClick}
                                        onStartClick={onStartClick}
                                        onStopClick={onStopClick}
                                        onDeleteClick={onDeleteClick}
                                    />
                                ))
                            ) : (
                                <></>
                            )}
                        </tbody>
                    </table>
                    <Pagination count={count} />
                </div>
                <Footer />
            </main>
            <PlanModal onSubmit={onPlanSubmit} data={editPlan} />
            <Toast
                type={notification.type}
                text={notification.text}
                onShow={() => setNotification({})}
            />
        </>
    );
}

export default Plans;
